import React, { useEffect, useState } from "react";
import { MDBCard } from "mdb-react-ui-kit";

function EmployeeDetails({ employeeData }) {
  return (
    <MDBCard className="empDetailsCard">
      <div className="empDetailsName">{employeeData["employee"]["name"]}</div>
      <hr className="hr hr-blurry" />

      <div className="empDetailsItem">
        <div>Current Job Title</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["job title"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Email Address</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["email"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Reporting To</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["role reporting to"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Entity</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["entity"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Experience</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["years of experience"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Nationality</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["nationality"]}
        </div>
      </div>
      <hr className="hr hr-blurry" />
      <div className="empDetailsItem">
        <div>Reporting To You</div>
        <div className="empDetailsMainText">
          {employeeData["employee"]["reporting to you"]}
        </div>
      </div>
    </MDBCard>
  );
}

export default EmployeeDetails;
